import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { AlertController, LoadingController } from '@ionic/angular';
import { AdminRemarksService } from 'src/app/providers/adminRemarks/admin-remarks.service';
import { UserDataService } from 'src/app/providers/userData/user-data.service';
import { Constants } from 'src/app/util/constants';

@Component({
	selector: 'app-admin-remarks',
	standalone: false,
	templateUrl: './admin-remarks.component.html',
	styleUrls: ['./admin-remarks.component.scss']
})
export class AdminRemarksComponent implements OnInit {
	// @Input() formId;
	@Input() form;

	isIQACADMIN: boolean = false;
	isCollegeADMIN: boolean = false;
	loggedInUserName: String = '';
	isFROMIQACDASHBOARD: boolean = false;
	remarkResolved: boolean = false;
	adminRemark: String = '';
	remarkPresent: boolean = false;
	sectionOpen: boolean = false;

	// Bottom Sheet Properties
	isBottomSheetOpen: boolean = false;

	constructor(
		public userdataService: UserDataService,
		public loadingController: LoadingController,
		public adminRemarksServie: AdminRemarksService,
		public alertController: AlertController
	) {}

	ngOnInit() {
		this.userdataService.getCurrentActiveSection().then((section) => {
			if (section) {
				if (section === 'IQAC_DASHBORAD') {
					this.isFROMIQACDASHBOARD = true;
				} else {
					this.isFROMIQACDASHBOARD = false;
				}
			}
		});
		this.checkLoggedInUserRole();
		this.userdataService.getUserProfile().then((profile) => {
			if (profile) {
				this.loggedInUserName = profile.emailId;
			}
		});
		// this.fetchAdminRemark(this.form);
	}

	async fetchAdminRemark(form: any) {
		const loader = await this.loadingController.create({
			message: 'Loading profile please wait ..'
		});
		loader.present();
		this.userdataService.getToken().then((token) => {
			// console.log("form object....");
			// console.log(this.form);
			let formId = form.id;
			if (token) {
				this.adminRemarksServie.getAdminRemark(token, formId).subscribe(
					(remark) => {
						loader.dismiss();
						if (remark && remark.remarks) {
							this.adminRemark = remark.remarks;
							this.remarkResolved = remark.resolved;
							this.remarkPresent = true;
						}
					},
					(error) => {
						loader.dismiss();
						this.userdataService.presentToast('Error fetching remark!', 'danger');
					}
				);
			} else {
				loader.dismiss();
			}
		});
	}

	checkLoggedInUserRole() {
		this.userdataService.getLoggedInUserRole().then((roles) => {
			if (roles) {
				let userRoles = [];
				userRoles = roles;
				if (userRoles.includes('IQAC_ADMIN')) {
					this.isIQACADMIN = true;
				}
				/* if (
          userRoles.includes("COLL_MGMT") ||
          userRoles.includes("PRINCIPAL_EQUI")
        ) {
          this.isCollegeADMIN = true;
        } else {
          this.isCollegeADMIN = false;
        } */
			} else {
				this.isIQACADMIN = false;
			}
		});
		this.userdataService.getUserProfile().then((profile) => {
			this.isCollegeADMIN = false;
			if (profile && profile.responsiblities) {
				profile.responsiblities.forEach((resp) => {
					if (
						resp.designation == 'ACADEMIC_AUDITOR' ||
						resp.designation == 'PRINCIPAL' ||
						resp.designation == 'COLLAGE_MGMT_REPRESENTATIVE' ||
						resp.designation == 'VICE_PRINCIPAL'
					) {
						this.isCollegeADMIN = true;
					}
				});
			}
		});
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['form'].currentValue && changes['form'].currentValue.id) {
			this.fetchAdminRemark(changes['form'].currentValue);
		}
	}

	isApproved(): boolean {
		return this.form.id && this.isIQACSubsection() && Constants.IS_APPROVED(this.form);
	}

	isIQACSubsection(): boolean {
		var result = this.isFROMIQACDASHBOARD;

		return true;
	}

	canUpdate(): boolean {
		if (this.form.status != undefined) {
			let isApproved = this.isApproved();
			let canUpdate = isApproved && this.isCollegeADMIN;
			return canUpdate;
		} else {
			return false;
		}
	}

	async markResolvedHandler() {
		const loader = await this.loadingController.create({
			message: 'Saving Remark. Please wait.'
		});
		loader.present();
		this.userdataService.getToken().then((token) => {
			let formId = this.form.id;
			if (token) {
				this.adminRemarksServie.resolveRemark(token, formId).subscribe(
					(remark) => {
						this.remarkResolved = true;
						loader.dismiss();
						this.userdataService.presentToast('Remark resolved successfully!', 'success');
					},
					(error) => {
						loader.dismiss();
						this.userdataService.presentToast('Remark not resolved!', 'danger');
					}
				);
			} else {
				loader.dismiss();
			}
		});
	}

	async markResolved() {
		let subHeaderToShow = 'Do you want to resolve remark for this form?';
		const alert = await this.alertController.create({
			// header: "Delete Remark",
			subHeader: subHeaderToShow,
			buttons: [
				{
					text: 'Yes',
					role: 'ok',
					handler: () => {
						this.markResolvedHandler();
					}
				},
				{
					text: 'No',
					role: 'cancel',
					handler: () => {
						console.log('cancel clicked');
					}
				}
			]
		});
		alert.present();
	}

	async markOpenHandler() {
		const loader = await this.loadingController.create({
			message: 'Saving Remark. Please wait.'
		});
		loader.present();
		this.userdataService.getToken().then((token) => {
			let formId = this.form.id;
			if (token) {
				this.adminRemarksServie.openRemark(token, formId).subscribe(
					(remark) => {
						this.remarkResolved = false;
						loader.dismiss();
						this.userdataService.presentToast('Remark opened successfully!', 'success');
					},
					(error) => {
						loader.dismiss();
						this.userdataService.presentToast('Remark not opened!', 'danger');
					}
				);
			} else {
				loader.dismiss();
			}
		});
	}

	async markOpen() {
		let subHeaderToShow = 'Do you want to open remark for this form?';
		const alert = await this.alertController.create({
			// header: "Delete Remark",
			subHeader: subHeaderToShow,
			buttons: [
				{
					text: 'Yes',
					role: 'ok',
					handler: () => {
						this.markOpenHandler();
					}
				},
				{
					text: 'No',
					role: 'cancel',
					handler: () => {
						console.log('cancel clicked');
					}
				}
			]
		});
		alert.present();
	}

	async saveRemarkHandler() {
		const loader = await this.loadingController.create({
			message: 'Saving Remark. Please wait.'
		});
		if (this.adminRemark == undefined || this.adminRemark == '') {
			this.userdataService.presentToast('Please enter remark!', 'danger');
			return;
		}
		loader.present();
		this.userdataService.getToken().then((token) => {
			let adminRemark = {
				formId: this.form.id,
				remark: this.adminRemark,
				isResolved: this.remarkResolved
			};
			if (token) {
				this.adminRemarksServie.saveRemarks(token, adminRemark).subscribe(
					(remark) => {
						loader.dismiss();
						this.remarkPresent = true;
						this.userdataService.presentToast('Remark saved successfully!', 'success');
					},
					(error) => {
						loader.dismiss();
						this.userdataService.presentToast('Remark not saved!', 'danger');
					}
				);
			} else {
				loader.dismiss();
			}
		});
	}

	async saveRemark() {
		let subHeaderToShow = 'Do you want to save  this remark?';
		const alert = await this.alertController.create({
			// header: "Delete Remark",
			subHeader: subHeaderToShow,
			buttons: [
				{
					text: 'Yes',
					role: 'ok',
					handler: () => {
						this.saveRemarkHandler();
					}
				},
				{
					text: 'No',
					role: 'cancel',
					handler: () => {
						console.log('cancel clicked');
					}
				}
			]
		});
		alert.present();
	}

	async deleteRemarkHandle() {
		const loader = await this.loadingController.create({
			message: 'Deleting Remark. Please wait.'
		});
		loader.present();
		this.userdataService.getToken().then((token) => {
			let formId = this.form.id;
			if (token) {
				this.adminRemarksServie.deleteRemark(token, formId).subscribe(
					(remark) => {
						this.remarkResolved = false;
						this.adminRemark = undefined;
						this.remarkPresent = false;
						loader.dismiss();
						this.userdataService.presentToast('Remark deleted successfully!', 'success');
					},
					(error) => {
						loader.dismiss();
						this.userdataService.presentToast('Remark not opened!', 'danger');
					}
				);
			} else {
				loader.dismiss();
			}
		});
	}

	async deleteRemark() {
		let subHeaderToShow = 'Do you want to delete this remark?';
		const alert = await this.alertController.create({
			// header: "Delete Remark",
			subHeader: subHeaderToShow,
			buttons: [
				{
					text: 'Yes',
					role: 'ok',
					handler: () => {
						this.deleteRemarkHandle();
					}
				},
				{
					text: 'No',
					role: 'cancel',
					handler: () => {
						console.log('cancel clicked');
					}
				}
			]
		});
		alert.present();
	}

	// Bottom Sheet Methods
	toggleBottomSheet() {
		this.isBottomSheetOpen = !this.isBottomSheetOpen;

		// Add body class for overlay styling when sheet is open
		if (this.isBottomSheetOpen) {
			document.body.classList.add('bottom-sheet-open');
		} else {
			document.body.classList.remove('bottom-sheet-open');
		}
	}

	closeBottomSheet() {
		this.isBottomSheetOpen = false;
		document.body.classList.remove('bottom-sheet-open');
	}

	openBottomSheet() {
		this.isBottomSheetOpen = true;
		document.body.classList.add('bottom-sheet-open');
	}

	getStatusIcon() {
		if (!this.remarkPresent) {
			return 'fas fa-circle-plus';
		}
		return this.remarkResolved ? 'fas fa-check-circle' : 'fas fa-exclamation-circle';
	}

	getStatusColor() {
		if (!this.remarkPresent) {
			return 'medium';
		}
		return this.remarkResolved ? 'success' : 'warning';
	}

	getStatusLabel() {
		if (!this.remarkPresent) {
			return 'No Remarks';
		}
		return this.remarkResolved ? 'Resolved' : 'Open';
	}
}
